export default __webpack_public_path__ + "static/AQP_Desk_display_tent_card-39b36662f3a1dbd23154883c49def01b.pdf";